'use strict'

var _ = require('lodash')
var DialogComponent = require('src/components/dialog-view')
var RgbColors = require('src/common/app-constants').rgbColors
var DimLevels = require('src/common/app-constants').dimLevels
var Helpers = require('src/common/helpers')
var App = require('app')

/**
 * Dialog body view
 * -----------------------------------------------------------------------------
 * Body of the dialog
 */
var dialogBodyDevice = DialogComponent.Body.extend({
 
  template: require('./templates/control.html'),
  regions: {
    routineRegion: '.routine__region'
  },
  events: {
    'change .js-preset-select': 'onPresetChange',
    'click .js-control-button': 'onControlButton'
  },
  onControlButton: function(ev) {
    let command = ev.currentTarget.getAttribute('data-command');
    let value = ev.currentTarget.getAttribute('data-value');

    this.triggerMethod('control:send-command', {
      command: command,
      value: value
    })
  },
  onPresetChange: function (ev) {
    this.triggerMethod('control:load-preset', this, ev.currentTarget.value)
  },
  templateContext: function () {
    var self = this
    return {

      hasControlButtons: function() {
        let buttons = _.get(self, 'options.controlButtons');
        if (!buttons) return false;
        return (buttons.length > 0);
      },
      getControlButtons: function() {
        if (_.has(self, 'options.controlButtons')) {
          return self.options.controlButtons
        }
      },
      getDimLevels: function () {
        return DimLevels
      },
      getRgbColors: function () {
        return RgbColors
      },
      getAttribute: App.TemplateHelpers.getAttribute,
      getPresetList: function () {
        var deviceType = self.options.deviceType
        if (!self.options.client) return false
        var clientPresets = self.options.client.get('presets')
        if (!clientPresets) return false
        return _.filter(clientPresets, function (o) { return o.deviceType === deviceType && o.type === 'control' })
      }
    }
  }
})

/**
 * Dialog body view (Xw Driver)
 * -----------------------------------------------------------------------------
 *
 */
var dialogBodyXwDriver = dialogBodyDevice.extend({})

/**
 * Dialog body view (Ird Driver)
 * -----------------------------------------------------------------------------
 *
 */
var dialogBodyIrdDriver = dialogBodyDevice.extend({
  template: require('./templates/control-ird.html'),
  regions: {
    routineRegion_dali: '.routine__region'
  },
  events: {
    'change .js-preset-select': 'onPresetChange',
    'click .js-dimlevel': 'onDimLevelChange',
    'click .js-control-button': 'onControlButton'

  },
  onDimLevelChange: function (e) {
    if (!e.target) return
    
    let level = e.target.getAttribute('data-dimlevel')

    // reset active state of currently active button
    Helpers.applyFnToElements(e.target.parentNode.querySelectorAll(".js-dimlevel"), (el) => {
      el.classList.remove('active');
    })

    e.target.classList.add('active');

    this.triggerMethod('control:send-command', {
      command: 'dali.set.arc_power',
      value: level
    })
  }
})

/**
 * Dialog body view (Ird Dali X Driver)
 * -----------------------------------------------------------------------------
 *
 */
var dialogBodyDaliXDriver = dialogBodyDevice.extend({
    template: require('./templates/control-dali-x.html'),
    events: {
      'change .js-preset-select': 'onPresetChange',
      'click .js-dimlevel': 'onDimLevelChange'
    },
    onDimLevelChange: function (e) {
      if (!e.target) return
      let level = e.target.getAttribute('data-dimlevel')

      // get the current selected channel
      let channelEl = this.el.querySelector(".js-channel")
      this.triggerMethod('control:send-command', {
        command: 'dali.set.arc_power',
        value: level,
        channel: channelEl.value
      })
    }
})


/**
 * Dialog body view (Ird Driver)
 * -----------------------------------------------------------------------------
 *
 */
var dialogBodyRtmIoDriver = dialogBodyDevice.extend({
  template: require('./templates/control-rtm-io.html'),
  regions: {
  },
  events: {
    'change .js-gpio': 'onGpioChange',
  },
  onGpioChange: function (ev) {
    if (!ev.target) return

    if (ev.target.value) {
      this.triggerMethod('control:send-command', {
        command: 'gpio.set.value',
        value: ev.target.value
      })
    }
  }
})

/**
 * Dialog body view (Ird-Rgb Driver)
 * -----------------------------------------------------------------------------
 *
 */
var dialogBodyIrdRgbDriver = dialogBodyDevice.extend({
  template: require('./templates/control-ird-rgb.html'),
  regions: {
    routineRegion_dali: '.routine__region-dali',
    routineRegion_color: '.routine__region-color'
  },
  events: {
    'change .js-preset-select': 'onPresetChange',
    'click .js-dimlevel': 'onDimLevelChange',
    //
    'change .js-color-ring-1': 'onRealtimeChangeColor1',
    'change .js-color-ring-2': 'onRealtimeChangeColor2'
  },
  onRealtimeChangeColor1: function (ev) {
    if (ev.target.value) {
      this.triggerMethod('control:send-command', {
        command: 'color.set.led1',
        value: ev.target.value
      })
    }
  },
  onRealtimeChangeColor2: function (ev) {
    if (ev.target.value) {
      this.triggerMethod('control:send-command', {
        command: 'color.set.led2',
        value: ev.target.value
      })
    }
  },
  onDimLevelChange: function (e) {
    if (!e.target) return
    let level = e.target.getAttribute('data-dimlevel')
    this.triggerMethod('control:send-command', {
      command: 'dali.set.arc_power',
      value: level
    })
  }
})


var dialogBodyZscRgbwDriver = dialogBodyDevice.extend({
  template: require('./templates/control-zsc-rgbw.html'),
  regions: {
    routineRegion_color_rgbw: '.routine__region-color_rgbw'
  },
  events: {
    'change .js-preset-select': 'onPresetChange',
    'click .js-dimlevel': 'onDimLevelChange',
    //
    'change .js-color-ring-1': 'onRealtimeChangeColor1',
    'change .js-color-ring-2': 'onRealtimeChangeColor2'
  },
  onRealtimeChangeColor1: function (ev) {
    if (ev.target.value) {
      this.triggerMethod('control:send-command', {
        command: 'color.set.led1',
        value: ev.target.value
      })
    }
  },
  onRealtimeChangeColor2: function (ev) {
    if (ev.target.value) {
      this.triggerMethod('control:send-command', {
        command: 'color.set.led2',
        value: ev.target.value
      })
    }
  },
  onDimLevelChange: function (e) {
    if (!e.target) return
    let level = e.target.getAttribute('data-dimlevel')
    this.triggerMethod('control:send-command', {
      command: 'dali.set.arc_power',
      value: level
    })
  }
})



/**
 * Dialog body view (Rgb Driver)
 * -----------------------------------------------------------------------------
 *
 */
var dialogBodyRgbDriver = dialogBodyDevice.extend({
  template: require('./templates/control-rgb.html'),
  regions: {
    routineRegion_color: '.routine__region'
  },
  events: {
    'change .js-preset-select': 'onPresetChange',
    'change .js-color-ring-1': 'onRealtimeChangeColor1',
    'change .js-color-ring-2': 'onRealtimeChangeColor2'
  },
  onRealtimeChangeColor1: function (ev) {
    if (ev.target.value) {
      this.triggerMethod('control:send-command', {
        command: 'color.set.led1',
        value: ev.target.value
      })
    }
  },
  onRealtimeChangeColor2: function (ev) {
    if (ev.target.value) {
      this.triggerMethod('control:send-command', {
        command: 'color.set.led2',
        value: ev.target.value
      })
    }
  }
})

module.exports.Body = dialogBodyDevice
module.exports.BodyXwDriver = dialogBodyXwDriver
module.exports.BodyIrdDriver = dialogBodyIrdDriver
module.exports.BodyDaliXDriver = dialogBodyDaliXDriver

module.exports.BodyRgbDriver = dialogBodyRgbDriver
module.exports.BodyIrdRgbDriver = dialogBodyIrdRgbDriver
module.exports.BodyRtmIoDriver = dialogBodyRtmIoDriver
module.exports.BodyZscRgbwDriver = dialogBodyZscRgbwDriver


/**
 * Wrapper view
 * -----------------------------------------------------------------------------
 * The dialog wrapper view
 */
var wrapperView = DialogComponent.Layout.extend({
  template: require('./templates/layout.html'),
  regions: {
    controlRegion: '.routine__control'
  },
  events: {
    'click .js-update-firmware': 'onFirmwareUpdate'
  },
  onFirmwareUpdate: function(ev) {
    let type = ev.currentTarget.getAttribute('data-firmware-type');

    let inputVal = this.el.querySelector('.js-firmware-version-ota').value;
    

      this.triggerMethod('control:update-firmware', this, {version:inputVal, type:type, command:ev.currentTarget.getAttribute('data-command')})

 



    return;

    let value = '';
    let command = ev.currentTarget.getAttribute('data-command');

    if (type == 'ota') {
      // do something with the payload fields
    } 

    this.triggerMethod('control:send-command', {
      command: command,
      value: value
    })
  },
  templateContext: function () {
    var self = this
    return {
      isDeviceType: function(type) {
        return (self.options.deviceType === type)
      },
      getDeviceTypes: App.TemplateHelpers.getDeviceTypes
    }
  }

})

module.exports.Wrapper = wrapperView


/**
 * Dialog view
 * -----------------------------------------------------------------------------
 * The dialog view
 */
var dialogView = DialogComponent.Layout.extend({
  className: 'dialog dialog-device-control',
  modelEvents: {
    'change': false
  }
})

module.exports.Layout = dialogView



// WEBPACK FOOTER //
// ./js/modules/devices/control/view.js